/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import {
  Container, Row, Col, Card, CardBody, Media, Button, Modal, ModalHeader, ModalBody, ModalFooter,
  FormGroup, Label, Input, Spinner,
} from 'reactstrap'
import Files from 'react-files'
import DatePicker from 'react-datepicker'
import Select from '../../../components/Template/Input/Select'
import DataTable from '../../../components/Template/Table/DataTable'
import MaskedInput from '../../../components/Template/Input/MaskedInput'
import Breadcrumbs from '../../../components/Common/Breadcrumb'
import { getWalletResume, getFullStatement, getRubrics, getSubRubrics, addExpense } from '../../../store/ducks/wallet'
import { selectValues, getRegs, insert, update, insOrUp, getDocs } from '../../../utils/fc'
import moment from 'moment'
import oikosApi from '../../../services/oikos'
import { notifySuccess, notifyError } from '../../../utils/notify'

class WalletResume extends Component {
  constructor(props) {
    super(props)
    this.state = {
      addApprovalModalIsOpen: false,
      tpDocumento_id: '',
      tpDocumento_idInputError: '',
      aprovacao_desc: '',
      aprovacao_descInputError: '',
      aprovacao_dtLimite: '',
      aprovacao_dtLimiteInputError: '',
      files: [],
      filesInputError: '',
      selTpDocumento: false,
      addApprovalIsLoading: false,
      Approval: {},
      listApprovals: [],
      listApprovalsIsLoading: false,
      resumeApprovals: {},
    }

    this.files = React.createRef()
  }

  componentDidMount() {
    this.preloading()
  }

  /*
  componentDidUpdate(prevProps) {
    const { getWalletResume, getFullStatement } = this.props
    const { addExpenseIsLoading, addExpenseSuccess } = this.props.wallet

    if (
      prevProps.wallet.addExpenseIsLoading !== addExpenseIsLoading
      && !addExpenseIsLoading
      && addExpenseSuccess
    ) {
      this.setState({ addApprovalModalIsOpen: false })
      getWalletResume()
      getFullStatement()
    }

    return true
  }*/

  preloading = async() => {
    this.setState({ selTpDocumento: await selectValues('tpDocumento', 'tpDocumento_id', 'tpDocumento_desc') })
    console.log('tipos de documentos = ', this.state.selTpDocumento)
    this.setState({ listApprovals: await getRegs('aprovacao') })
    console.log('itens a serem aprovados = ', this.state.listApprovals)
    /*const data = {
      // aprovacao_id: 2,
      tpDocumento_id: 1,
      aprovacao_desc: 'teste insOrUp ' + Math.random(),
      aprovacao_dtLimite:  moment("02/06/2023").format('YYYY-MM-DD'),
      pf_autor: 1,
    }
    insOrUp('aprovacao', data)*/
    console.log('documentos e arquivos associados ', await getDocs('prod', 1351))
  }

  toggleModal = () => {
    const { addApprovalIsLoading } = this.state

    if (addApprovalIsLoading) {
      return null
    }

    this.setState(prevState => ({
      addApprovalModalIsOpen: !prevState.addApprovalModalIsOpen,
    }))

    return null
  }

  handleAddApprovalSubmit = async () => {
    const { Approval } = this.state
    const { aprovacao_id, tpDocumento_id, aprovacao_desc, aprovacao_dtLimite, files } = Approval
    if (!tpDocumento_id) this.setState({ tpDocumento_idInputError: 'Campo obrigatório.' })
    if (!aprovacao_desc) this.setState({ aprovacao_descInputError: 'Campo obrigatório.' })
    if (!aprovacao_dtLimite) this.setState({ aprovacao_dtLimiteInputError: 'Campo obrigatório.' })
    if (!files || files.length <= 0) this.setState({ filesInputError: 'Adicione ao menos um anexo.' })

    if (tpDocumento_id && aprovacao_desc && aprovacao_dtLimite && files && files.length > 0) {
      if (!aprovacao_id) {
        // Será necessário criar um novo registro
        try {
          const insertApproval = {
            action: 'insert',
            table: 'aprovacao',
            data: {
              tpDocumento_id,
              aprovacao_desc,
              aprovacao_dtLimite:  moment(aprovacao_dtLimite).format('YYYY-MM-DD')
            },
          }
          console.log('insertApproval ', insertApproval)
          const approvalCreated = await oikosApi.post('/', insertApproval)
          notifySuccess('Aprovação cadastrada com sucesso.')
          //Atualizar lista de aprovações
        } catch (e) {
          notifyError('Erro ao cadastrar aprovação')
          console.log('Não foi possível a aprovação.', e)
        }
      } else {
        // O produto está sendo editado. Basta usar a rota de atualização
        try {
          const updateApproval = {
            action: 'update',
            table: 'aprovacao',
            data: {
              aprovacao_id,
              tpDocumento_id,
              aprovacao_desc,
              aprovacao_dtLimite:  moment(aprovacao_dtLimite).format('YYYY-MM-DD')
            },
          }
          console.log('updateApproval ', updateApproval)
          const approvalUpdated = await oikosApi.post('/', updateApproval)
          notifySuccess('Aprovação atualizada com sucesso.')
          //Atualizar lista de aprovações
        } catch (e) {
          notifyError('Erro ao atualizar a aprovação');
          console.log('Não foi possível atualizazar a aprovação.', e)
        }
      }
      this.setState({ addApprovalModalIsOpen: false })
    }

    return null
  }

  render() {
    const {
      listApprovalsIsLoading,
      listApprovals,
      resumeApprovals,
      Approval,
      addApprovalIsLoading,
      addApprovalModalIsOpen,
      tpDocumento_idInputError,
      aprovacao_descInputError,
      aprovacao_dtLimiteInputError,
      filesInputError,
      selTpDocumento,
      files,
    } = this.state

//    const { aprovacao_id, tpDocumento_id, aprovacao_desc, aprovacao_dtLimite, files } = Approval


    if (listApprovalsIsLoading) {
      return (
        <div className="centered">
          <Spinner />
        </div>
      )
    }

    if (listApprovalsIsLoading) {
      return (
        <div className="page-content">
          <Modal
            centered
            isOpen={addApprovalModalIsOpen}
            toggle={() => this.toggleModal()}
          >
            <ModalHeader toggle={() => this.toggleModal()}>
              Adicionar aprovação
            </ModalHeader>
            <ModalBody>
              <FormGroup className="select2-container">
                <Label>Tipo de documento</Label>
                <Select
                  classNamePrefix="select2-selection"
                  placeholder="Selecionar..."
                  value={Approval?.tpDocumento_id}
                  options={selTpDocumento || []}
                  isDisabled={!selTpDocumento}
                  isLoading={!selTpDocumento}
                />
                {tpDocumento_idInputError && <span style={{ color: 'red' }}>{tpDocumento_idInputError}</span>}
              </FormGroup>
              <FormGroup>
                <Label>Descrição</Label>
                <Input
                  className="form-control"
                  type="text"
                  value={Approval?.aprovacao_desc}
                  onChange={e => this.setState({
                    Approval: {
                      ...Approval,
                      aprovacao_desc: e.target.value || null,
                    },
                    aprovacao_descInputError: '',
                  })}
                />
                {
                  aprovacao_descInputError
                  && (
                    <span style={{ color: 'red' }}>
                      {aprovacao_descInputError}
                    </span>
                  )
                }
              </FormGroup>
              <FormGroup>
                <Label>Data Limite para aprovação</Label>
                <DatePicker
                    placeholderText="__/__/_____"
                    locale="pt-BR"
                    className="form-control"
                    dateFormat="dd/MM/yyyy"
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    selected={Approval?.aprovacao_dtLimite ? moment(Approval?.aprovacao_dtLimite).toDate() : null}
                    onChange={aprovacao_dtLimite => this.setState({
                      Approval: {
                        ...Approval,
                        aprovacao_dtLimite },
                      aprovacao_dtLimiteInputError: '',
                  })}
                />
                {
                  aprovacao_dtLimiteInputError
                  && (
                    <span style={{ color: 'red' }}>
                      {aprovacao_dtLimiteInputError}
                    </span>
                  )
                }
              </FormGroup>
              <Row>
                <Col>
                  <Label>Anexos</Label>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Button
                    outline
                    color="primary"
                    type="button"
                    className="mb-3 mt-1"
                    size="sm"
                  >
                    <Files
                      multiple
                      clickable
                      ref={this.files}
                      onChange={files => {
                        this.setState({ files, filesInputError: '' })
                      }}
                      onError={(error) => notifyError(error.message)}
                      accepts={['.pdf']}
                      maxFiles={3}
                      maxFileSize={10000000}
                      minFileSize={1}
                    >
                      <i className="ri-attachment-2 align-middle mr-2" />
                      <span className="align-middle">Adicionar aprovação</span>
                    </Files>
                  </Button>
                </Col>
              </Row>
              <Row>
                <Col>
                  {files && files.length > 0 && (
                    <div className="files-list">
                      <ul>
                        {files.map((file) => (
                          <li className="files-list-item" key={file.id}>
                            <div className="files-list-item-preview">
                              {file.preview.type === 'image'
                                ? <img className="files-list-item-preview-image" alt="Prévia de arquivo" src={file.preview.url} />
                                : <div className="files-list-item-preview-extension">{file.extension}</div>}
                            </div>
                            <div className="files-list-item-content">
                              <div className="files-list-item-content-item files-list-item-content-item-1">{file.name}</div>
                              <div className="files-list-item-content-item files-list-item-content-item-2">{file.sizeReadable}</div>
                            </div>
                            <div
                              id={file.id}
                              className="files-list-item-remove"
                              onClick={() => this.files.current.removeFile(file)}
                            />
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                  {
                    filesInputError
                    && (
                      <span style={{ color: 'red' }}>
                        {filesInputError}
                      </span>
                    )
                  }
                </Col>
              </Row>
            </ModalBody>
            <ModalFooter>
              <Button
                type="button"
                onClick={() => this.toggleModal()}
                color="light"
                className="waves-effect"
                disabled={addApprovalIsLoading}
              >
                Cancelar
              </Button>
              <Button
                type="button"
                color="primary"
                className="waves-effect waves-light"
                onClick={() => this.handleAddApprovalSubmit()}
                disabled={addApprovalIsLoading}
              >
                Adicionar
                {addApprovalIsLoading && (
                  <Spinner size="sm" className="ml-2" />
                )}
              </Button>
            </ModalFooter>
          </Modal>

          <Container fluid>

            <Breadcrumbs
              title="Aprovações"
              breadcrumbItems={[]}
            />

            <Row className="mb-3">
              <Col>
                <h4>
                  Resumo
                </h4>
              </Col>
            </Row>

            <Row>
              <Col>
                <Card>
                  <CardBody>
                    <Media>
                      <Media body className="overflow-hidden">
                        <p className="text-truncate font-size-14 mb-2">A avaliar</p>
                        <h5 className="mb-0">
                          R$
                          {' '}
                          {resumeApprovals.entradas.toFixed(2).replace('.', ',')}
                        </h5>
                      </Media>
                    </Media>
                  </CardBody>
                </Card>
              </Col>
              <Col>
                <Card>
                  <CardBody>
                    <Media>
                      <Media body className="overflow-hidden">
                        <p className="text-truncate font-size-14 mb-2">Vencendo hoje</p>
                        <h5 className="mb-0">
                          R$
                          {' '}
                          {resumeApprovals.saidas.toFixed(2).replace('.', ',')}
                        </h5>
                      </Media>
                    </Media>
                  </CardBody>
                </Card>
              </Col>
              <Col>
                <Card>
                  <CardBody>
                    <Media>
                      <Media body className="overflow-hidden">
                        <p className="text-truncate font-size-14 mb-2">Aguardando outros</p>
                        <h5 className="mb-0">
                          R$
                          {' '}
                          {resumeApprovals.diferenca.toFixed(2).replace('.', ',')}
                        </h5>
                      </Media>
                    </Media>
                  </CardBody>
                </Card>
              </Col>
              <Col>
                <Card>
                  <CardBody>
                    <Media>
                      <Media body className="overflow-hidden">
                        <p className="text-truncate font-size-14 mb-2">Criadas por mim</p>
                        <h5 className="mb-0">
                          R$
                          {' '}
                          {resumeApprovals.diferenca.toFixed(2).replace('.', ',')}
                        </h5>
                      </Media>
                    </Media>
                  </CardBody>
                </Card>
              </Col>
            </Row>

            <Row className="mb-3 mt-1">
              <Col>
                <h4>
                  Pendências
                </h4>
              </Col>
              <Col style={{ textAlign: 'right' }}>
                {true && (
                  <Button
                    color="primary"
                    type="button"
                    onClick={() => this.toggleModal()}
                  >
                    Adicionar pendência
                  </Button>
                )}
              </Col>
            </Row>

            <Row>
              <Col>
                <Card>
                  <CardBody>
                    <DataTable
                      sortable={false}
                      data={{
                        columns: [
                          {
                            label: 'ID',
                            field: 'mov_id',
                          },
                          {
                            label: 'Data',
                            field: 'mov_dtQuit',
                          },
                          {
                            label: 'Rubrica',
                            field: 'rubrica_nome',
                          },
                          {
                            label: 'Descrição',
                            field: 'mov_desc',
                          },
                          {
                            label: 'Valor',
                            field: 'mov_vlr',
                          },
                        ],
                        rows: listApprovals.map(item => ({
                          ...item,
                          mov_vlr: `${Number(item.mov_vlr) < 0 ? '-' : ''}R$ ${Math.abs(Number(item.mov_vlr).toFixed(2)).toString().replace('.', ',')}`,
                        })),
                      }}
                    />
                  </CardBody>
                </Card>
              </Col>
            </Row>

          </Container>
        </div>
      )
    }

    return null
  }
}

const mapStateToProps = state => ({ wallet: state.wallet })
const mapDispatchToProps = dispatch => bindActionCreators({
  getWalletResume,
  getFullStatement,
  getRubrics,
  addExpense,
  getSubRubrics,
}, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(WalletResume)
